module.exports = __webpack_public_path__ + "img/bc_logo_print.edde7ab9.svg";